
<body>
<div class="wrapper">
  <div class="container">
    <div class="row">
      <div class="col-sm-10 m-auto">
        <div class="login-logo mb-3" *ngIf="order?.accountOwnerLogo">
          <a href="{{order.accountOwnerWebsite}}" target="_blank">
            <img alt="logo" class="img-fluid" height="120" src="{{order?.accountOwnerLogo}}" width="120"></a>
        </div>
        <div *ngIf="!order.accountOwnerLogo" class="label mb-3">
          <label class="p-3">{{order.accountOwnerCompany}}</label>
        </div>
      </div>

      <div class="row" *ngIf="trackingMenuList?.length > 0">
        <div class="col">
          <div class="topnav m-3">
            <a *ngFor="let trackMenu of trackingMenuList ; let i = index;" style="color:white"
               href="{{trackMenu.menuUrl}}" target="_blank">{{trackMenu.menuName}}&nbsp;&nbsp;<span
              *ngIf="i !== trackingMenuList.length-1"> | </span> &nbsp;&nbsp; </a>
          </div>
        </div>
      </div>
      <div class="row mt-2" *ngIf="track1?.webBanner != null">
        <div class="col">
          <a>
            <img alt="{{track1.altText || 'no banner'}}" class="img-fluid" height="120" src="{{track1?.webBanner}}"
                 width="120"></a>
        </div>
      </div>



      <!--USER ACCESS ELEMENTS-->


      <!--<div class="branded-sec-btn py-4 mt-5 clearfix ">
        <a (click)="submitOtp('cancel')"
           *ngIf="order?.orderStatus != 'DELIVERED' && order?.orderStatus != 'COMPLETED'"
           class="icon-left link-blue-primary float-end">
          <svg fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.59732 5.3966L5.40265 8.59127M8.59831 8.5932L5.40098 5.3952M9.88998 0.833466H4.11065C2.09665 0.833466 0.833984 2.25947 0.833984 4.27747V9.7228C0.833984 11.7408 2.09065 13.1668 4.11065 13.1668H9.88932C11.91 13.1668 13.1673 11.7408 13.1673 9.7228V4.27747C13.1673 2.25947 11.91 0.833466 9.88998 0.833466Z"
              stroke="#2196F3" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
          </svg>
          Request for Cancellation
        </a>
        &lt;!&ndash;(click)="submitOtp('return')"&ndash;&gt;
        <a (click)="navigate()"
           *ngIf="order?.orderStatus == 'DELIVERED' || order?.orderStatus == 'COMPLETED'"
           class="icon-left link-blue-primary float-end">
          <svg fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.59732 5.3966L5.40265 8.59127M8.59831 8.5932L5.40098 5.3952M9.88998 0.833466H4.11065C2.09665 0.833466 0.833984 2.25947 0.833984 4.27747V9.7228C0.833984 11.7408 2.09065 13.1668 4.11065 13.1668H9.88932C11.91 13.1668 13.1673 11.7408 13.1673 9.7228V4.27747C13.1673 2.25947 11.91 0.833466 9.88998 0.833466Z"
              stroke="#2196F3" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
          </svg>
          Request for Return
        </a>
      </div>-->
      <div class="branded-sec pb-4">
        <div class="row">
          <div class="col-lg-4 col-md-6 delivery">
            <div class="white-box">
              <div class="box-head">
                <div class="row">
                  <div class="col-sm-12">
                    <h6 class="heading-bold" *ngIf="status == 'SUBMITTED'||'RETURN'">Estimated Pickup Date</h6>
                    <h6 class="heading-bold" *ngIf="status == 'AWAITING_CARRIER'">Order Picked On</h6>
                  </div>
                </div>
              </div>

              <div class="date-sec">
                <p class="text-center link-black">{{estimatedDelivery | date : "EEEE"}}</p>
                <h2 class="text-center link-orange-primary">{{estimatedDelivery | date : "MMMM"}}</h2>
                <h4 class="text-center link-orange-primary">{{estimatedDelivery | date : "d"}}</h4>
                <span class="badge bg-orange-primary">{{order?.orderStatus}}</span>
                <h3 class="link-blue-primary text-center mb-2">Shipped By -
                  {{(order?.shippingOption == 'SD' ? 'Shift' :
                  (order?.shippingOption == 'DL' ? 'Delhivery' :
                  (order?.shippingOption == 'GT' ? 'Gati' :
                  (order?.shippingOption == 'DZ' ? 'Dotzot' :
                  (order?.shippingOption == 'RD' ? 'Rapid Delivery' :
                  (order?.shippingOption == 'SF' ? 'Shadow Fax' :
                  (order?.shippingOption == 'BD' ? 'Blue Dart' :
                  (order?.shippingOption == 'PR' ? 'Pickrr' :
                  (order?.shippingOption == 'SY' ? 'Ship Yaari' :
                  (order?.shippingOption == 'DE' ? 'Delhivery' :
                  (order?.shippingOption == 'SG' ? 'Shippigo' :
                  (order?.shippingOption == 'VS' ? 'Vamaship' :
                  (order?.shippingOption == 'DN' ? 'Dunzo' :
                  (order?.shippingOption == 'WF' ? 'Borzo' :
                  (order?.shippingOption == 'UE' ? 'UdaanExpress' :
                  (order?.shippingOption == 'FE' ? 'FedEx' : order?.shippingOption))))))))))))))))}} </h3>
                <h3 class="link-blue-primary text-center">Tracking ID - {{order?.trackingNumbers}}</h3>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="white-box " style="float:left;height: 423px;overflow-y: auto;">
              <div class="box-head">
                <div class="row">
                  <div class="col-sm-12">
                    <h6 class="heading-bold">Track Order</h6>
                  </div>
                </div>
              </div>
              <div class="tracklist">
                <ul>
                  <li *ngFor="let t of getTrackOrderData">
                      <span
                        [ngClass]="{'bg-blue-secondary':t.status === 'SUBMITTED','bg-green':t.status === 'DELIVERED' || t.status === 'COMPLETED','bg-purple':t.status !== 'DELIVERED' && t.status !=='SUBMITTED' && t.status !=='COMPLETED'}"
                        class="badge">
                    {{(t.status == 'SUBMITTED' ? 'Order Placed' :
                     t.status | replaceStatus)}}</span>
                    <p>{{t.activityDate}}</p>
                    <p>{{t.description}}</p>
                  </li>
                  <a type="button" data-bs-toggle="collapse" data-bs-target="#carrierData"
                     class="badge bg-orange-primary">Carrier Details</a>
                  <li id="carrierData" class="collapse" *ngFor="let t of getCarrierTrackOrderData">
                      <span
                        [ngClass]="{'bg-blue-secondary':t.status === 'SUBMITTED','bg-green':t.status === 'DELIVERED' || t.status === 'COMPLETED','bg-purple':t.status !== 'DELIVERED' && t.status !=='SUBMITTED' && t.status !=='COMPLETED'}"
                        class="badge">
                    {{t.carrierStatus}}</span>
                    <p>{{t.carrierActivityDate}}</p>
                    <p>{{t.carrierDescription}}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-12">
            <div class="white-box additional-info mt-0 order-shiping-info" style="height:423px;">
              <div class="box-head">
                <div class="row">
                  <div class="col-sm-12">
                    <h6 class="heading-bold">Order Details</h6>
                  </div>
                </div>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-md-6">
                    <label>Order#</label>
                    <p>{{order?.orderNumber}}</p>
                  </div>
                  <div class="col-md-6">
                    <label>Order Date</label>
                    <p>{{order?.createdDate}}</p>
                  </div>
                  <div *ngIf="order?.sourceOrderId !== null" class="col-md-6">
                    <label>Source Order#</label>
                    <p>{{order?.sourceOrderId}}</p>
                  </div>
                  <div class="col-md-6">
                    <label>Name of the Buyer</label>
                    <p>{{order?.receiverName}}</p>
                  </div>
                  <div class="col-md-6">
                    <label>Phone Number</label>
                    <p>{{order?.receiverMobile}}</p>
                  </div>
                  <div class="col-md-12">
                    <label>Address</label>
                    <p>{{order?.receiverAddressText}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</body>
